import { type MediaDataRoomParticipantPermission } from "features/mediaDataRoom/models";

export const mediaDataRoomOrganizationPermissionsAsColumnHeaders: Record<
  MediaDataRoomParticipantPermission,
  { title: string; tooltip: string; order: number }
> = {
  CREATE_CUSTOM_AUDIENCE: {
    order: 5,
    title: "Create audiences",
    tooltip: `If enabled, this participant can create audiences and share them with other participants. Note that to export audiences from the DCR, the "Export audiences" permission is needed.`,
  },
  EXPORT_AUDIENCE: {
    order: 6,
    title: "Export audiences",
    tooltip:
      "If enabled, this participant can export audiences from the DCR. This includes audiences they created as well as audiences that were shared with them.",
  },
  MODEL_QUALITY: {
    order: 7,
    title: "Model quality",
    tooltip: "Test",
  },
  PROVIDE_BASE_AUDIENCE: {
    order: 2,
    title: "Provide base audience",
    tooltip:
      "If enabled, this participant will have to provide the base audience. This permission is exclusive to one participant at a time.",
  },
  PROVIDE_SEED_AUDIENCE: {
    order: 1,
    title: "Provide seed audience",
    tooltip:
      "If enabled, this participant will have to provide the seed audience. This permission is exclusive to one participant at a time.",
  },
  VIEW_INSIGHTS: {
    order: 4,
    title: "View insights",
    tooltip:
      "If enabled, this participant will have access to the insights dashboards.",
  },
  VIEW_OVERLAP: {
    order: 3,
    title: "View overlap",
    tooltip:
      "If enabled, this participant will have access to the overlap statistics.",
  },
};
